import { defineComponent as t, computed as c, openBlock as r, createBlock as p, unref as s } from "vue";
import d from "../assets/icons/chevron-down.svg.mjs";
const u = /* @__PURE__ */ t({
  __name: "chevron-down-icon",
  props: {
    fill: { default: "currentColor" },
    size: { default: "md" }
  },
  setup(e) {
    const l = e, o = {
      sm: "12px",
      md: "16px",
      lg: "24px",
      xl: "32px",
      "2xl": "48px"
    }, i = c(() => o[l.size]);
    return (n, a) => (r(), p(s(d), {
      fill: n.fill,
      width: i.value,
      style: {
        verticalAlign: "middle",
        display: "inline-block",
        height: "auto"
      }
    }, null, 8, ["fill", "width"]));
  }
});
export {
  u as default
};
//# sourceMappingURL=chevron-down-icon.vue.mjs.map
